module.exports = __webpack_public_path__ + "img/form-brillant@2x.57006e7.webp";